var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fb fb-cross-center fb-main-end",on:{"click":_vm.handleChooseClass}},[_c('span',{staticClass:"c-171A1D mr-4 text-ellipsis inline-block current-class"},[_vm._v(_vm._s(_vm.cpCurrentClass.name || ''))]),(_vm.cpClassList && _vm.cpClassList.length > 1)?_c('i',{staticClass:"iconfont"},[_vm._v("")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }